// @core/api/endpoints/document/create_document_from_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateDocumentFromTemplateRequest,
  DocumentResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create from template
 * Creates a new document populated with template defaults, variable substitution, and auto-numbering. When scope_entity is provided, entity fields are used for variable resolution.
 */
export async function CreateDocumentFromTemplate(
  template_id: string,
  data: CreateDocumentFromTemplateRequest,
  options?: RequestOptions
): Promise<DocumentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-templates/:template_id/create`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.post<DocumentResponse>(requestPath, data, requestOptions);
}
